import { INTERNAL_DOMAINS_LIST } from 'src/constants/domains';

export const isWebsiteInternallyRouted = (domain) => {
  if (!domain) return false;
  return !!INTERNAL_DOMAINS_LIST.find((internalDomain) =>
    domain.includes(internalDomain)
  );
};
